import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import './dx-styles.scss';
import LoadPanel from 'devextreme-react/load-panel';
import { NavigationProvider } from './contexts/navigation';
import { AuthProvider, useAuth } from './contexts/auth';
import { useScreenSizeClass } from './utils/media-query';
import Content from './Content';
import UnauthenticatedContent from './UnauthenticatedContent';
import { useEffect } from 'react';
import { applyDashboardLocalization } from './localization/dashboard-localization';
import UpdateBanner from './components/update-banner/UpdateBanner';
import { useAppVersionCheck } from './hooks/useAppVersionCheck';

applyDashboardLocalization();

function App() {
  const { user, loading } = useAuth();

  useEffect(() => {
    if (window.location.hostname !=='localhost' && window.location.protocol === 'http:') {
      window.location.href =
        window.location.href.replace(
          'http:', 'https:');
    }
  }, []);

  if (loading) {
    return <LoadPanel visible={true} />;
  }

  if (user) {
    return <Content />;
  }

  return <UnauthenticatedContent />;
}

export default function Root() {
  const screenSizeClass = useScreenSizeClass();
  const { updateAvailable, reloadApp } = useAppVersionCheck();

  return (
    <Router>
      <AuthProvider>
        <NavigationProvider>
          <UpdateBanner visible={updateAvailable} onReload={reloadApp} />
          <div className={`app ${screenSizeClass}`}>
            <App />
          </div>
        </NavigationProvider>
      </AuthProvider>
    </Router>
  );
}
